import React, {Component} from 'react';
import SystemTranslationLocaleForm from "./SystemTranslationLocaleForm";
import SystemTranslationLocaleService from "../../services/SystemTranslationLocaleService";
import {observer} from "mobx-react";
import Dialog from "../../../../core/layout/Dialog";

class SystemTranslationLocaleFormContainer extends Component {

    render() {
        return (
            <Dialog
                title="Create Locale"
                isOpen={SystemTranslationLocaleService.formOpened}
                onCancel={SystemTranslationLocaleService.closeForm}
                actions={null}
            >
            <SystemTranslationLocaleForm
                values={SystemTranslationLocaleService.form.getValues()}
                onChange={SystemTranslationLocaleService.form.setValue}
                onReset={SystemTranslationLocaleService.form.reset}
                onSubmit={SystemTranslationLocaleService.handleSubmit}
                errors={SystemTranslationLocaleService.form.errors}
                submitting={SystemTranslationLocaleService.submit.fetching}
                isDirty={SystemTranslationLocaleService.form.isDirty}
            />
            </Dialog>
        );
    }

}

export default observer(SystemTranslationLocaleFormContainer);